module.exports = __webpack_public_path__ + "img/orange-exclamation.4b26d056.svg";